import { oc } from '@orpc/contract';
import { invalidateRunInputSchema, runDetailSchema } from '../schemas/runs.schemas.js';
export const invalidateRunContract = oc
    .route({
    method: 'POST',
    path: '/runs/{id}/invalidate',
    tags: ['Runs'],
    summary: 'Manually mark a run invalid with a reason',
    description: 'MANAGER only. The note is recorded as a `manual_override` verdict so the override is as traceable as a rule failure.',
})
    .input(invalidateRunInputSchema)
    .output(runDetailSchema);
//# sourceMappingURL=invalidate-run.contract.js.map